/* unplugin-vue-components disabled */import script from "./QaInfoView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./QaInfoView.vue?vue&type=script&lang=tsx&setup=true"

import "./QaInfoView.vue?vue&type=style&index=0&id=c0ba7970&lang=less"
import "./QaInfoView.vue?vue&type=style&index=1&id=c0ba7970&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ba7970"]])

export default __exports__